"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tabs = /*#__PURE__*/function () {
  function Tabs(container) {
    _classCallCheck(this, Tabs);

    this.container = container;
    this.tabsToggles = _toConsumableArray(container.getElementsByClassName('tab-toggle'));
    this.tabsContents = _toConsumableArray(container.getElementsByClassName('tab-content'));
    this.contentContainer = _toConsumableArray(container.getElementsByClassName('tab-container'))[0];
    this.delay = this.tabsContents.length ? this.getTransition(this.tabsContents[0]) : 1000;
    this.init();
  }

  _createClass(Tabs, [{
    key: "init",
    value: function init() {
      this.listen();

      if (this.activeTab) {
        this.activeTab.click();
      } else {
        this.tabsToggles[0].click();
      }
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      this.tabsToggles.forEach(function (item) {
        _this.activeTab = item.classList.contains('is-active') ? item : _this.activeTab;
        item.addEventListener('click', function () {
          var target = item.dataset.target;

          var activeContent = _this.tabsContents.find(function (content) {
            return content.dataset.content == target;
          });

          if (!activeContent.classList.contains('is-active')) {
            _this.nextContent = activeContent;

            _this.setPositions();

            _this.unsetClasses();

            _this.activeTab = item;
            _this.activeContent = activeContent;

            _this.setClasses();
          }
        });
      });

      if (this.contentContainer) {
        window.addEventListener('resize', function () {
          return _this.resize();
        });
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      this.contentContainer.style.height = "".concat(this.activeContent.offsetHeight, "px");
    }
  }, {
    key: "unsetClasses",
    value: function unsetClasses() {
      if (this.activeTab) {
        this.activeTab.classList.remove('is-active');
      }

      if (this.activeContent) {
        var activeContent = this.activeContent;
        this.activeContent.classList.remove('is-active');
        setTimeout(function () {
          activeContent.style.display = 'none';
        }, this.delay);
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses() {
      var _this2 = this;

      this.activeTab.classList.add('is-active');
      setTimeout(function () {
        _this2.activeContent.style.display = 'block';
      }, this.delay);
      setTimeout(function () {
        if (_this2.contentContainer) {
          _this2.resize();
        }

        _this2.activeContent.classList.add('is-active');
      }, this.delay + 100);
    }
  }, {
    key: "setPositions",
    value: function setPositions() {
      var _this3 = this;

      var position = 'prev';
      this.tabsContents.forEach(function (content) {
        if (content === _this3.nextContent) {
          position = 'next';
          return;
        }

        content.classList.remove('is-next', 'is-prev');
        content.classList.add("is-".concat(position));
      });
    }
  }, {
    key: "getTransition",
    value: function getTransition(element) {
      var transition = getComputedStyle(element).transitionDuration.replace('s', '');
      return parseInt(transition, 10) * 1000;
    }
  }]);

  return Tabs;
}();

var tabs = _toConsumableArray(document.getElementsByClassName('js-tabs'));

if (tabs.length) {
  tabs.forEach(function (tab) {
    return new Tabs(tab);
  });
}